import { useState, useEffect } from "react";

export const useValidateQueryParams = () => {
  const [queryParams, setQueryParams] = useState("");

  useEffect(() => {
    const getValidateUTMParams = () => {
      const queryParams = new Set([
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
        "invite_code",
      ]);

      const currentLocationParams = new URLSearchParams(window.location.search);

      const validUTMs = [];

      currentLocationParams.forEach((value, key) => {
        if (queryParams.has(key)) {
          validUTMs.push(`${key}=${value}`);
        }
      });

      return validUTMs.join("&");
    };

    const params = getValidateUTMParams();
    setQueryParams(params);
  }, []);

  return queryParams;
};
